export const API_BASE_URL = process.env.REACT_APP_API_URL
    // use env if set
    ? process.env.REACT_APP_API_URL
    // default to wte.local for dev
    : (
        process.env.NODE_ENV !== 'production'
                ? 'http://localhost:8080'
                : ''
    );

export const API_CORPORATE_URL = process.env.REACT_APP_CORPORATE_API_URL
    // use env if set
    ? process.env.REACT_APP_CORPORATE_API_URL
    // default to corporate.local for dev
    : (
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:8082'
            : ''
    );

export const CORPORATE_URL: string = process.env.REACT_APP_CORPORATE_URL
    // use env if set
    ? process.env.REACT_APP_CORPORATE_URL
    // default to toolbox local for dev
    : (
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:3002'
            : ''
    );

export const MANAGE_URL: string = process.env.REACT_APP_MANAGE_URL
    // use env if set
    ? process.env.REACT_APP_MANAGE_URL
    // default to manage local for dev
    : (
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:3007'
            : ''
    );

export const LOGIN_URL: string = process.env.REACT_APP_LOGIN_URL
    // use env if set
    ? process.env.REACT_APP_LOGIN_URL
    // default to login local for dev
    : (
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:3006'
            : ''
    );

export const PUBLIC_URL: string = process.env.REACT_APP_PUBLIC_URL
    // use env if set
    ? process.env.REACT_APP_PUBLIC_URL
    // default to toolbox local for dev
    : '/';

/**
 * Site title to be used in the title tag in head.
 *
 * @var {string}
 */
export const SITE_TITLE = "Writer's Toolbox";

/**
 * The Google app id for logging in with Google.
 *
 * @var {string}
 */
export const GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID;

/**
 * Separator for site title and the page name.
 *
 * @var {string}
 */
export const SITE_TITLE_SEPARATOR = " - ";

export const getSiteTitle = (pageTitle: string) => pageTitle ? pageTitle + SITE_TITLE_SEPARATOR + SITE_TITLE : SITE_TITLE;
